import applyGitLabUIConfig from '@gitlab/ui/src/config';
import { __, s__, n__ } from '~/locale';
import {
  PREV,
  NEXT,
  LABEL_FIRST_PAGE,
  LABEL_PREV_PAGE,
  LABEL_NEXT_PAGE,
  LABEL_LAST_PAGE,
} from '~/vue_shared/components/pagination/constants';

applyGitLabUIConfig({
  firstDayOfWeek: gon.first_day_of_week,
  accessibleDisabledButton: true,
  translations: {
    'ClipboardButton.copied': __('Copied'),
    'ClipboardButton.error': __('Copy failed'),
    'ClipboardButton.title': __('Copy to clipboard'),
    'CloseButton.title': __('Close'),
    'GlAlert.closeButtonTitle': __('Dismiss'),
    'GlBanner.closeButtonTitle': __('Dismiss'),
    'GlBreadcrumb.showMoreLabel': __('Show more breadcrumbs'),
    'GlBroadcastMessage.closeButtonTitle': __('Dismiss'),
    'GlChartLegend.average': __('Avg'),
    'GlChartLegend.current': __('Current'),
    'GlChartLegend.max': __('Max'),
    'GlChartLegend.min': __('Min'),
    'GlCollapsibleListbox.loadingAnnouncementText.loadingItems': __('Loading items'),
    'GlCollapsibleListbox.loadingAnnouncementText.loadingMoreItems': __('Loading more items'),
    'GlCollapsibleListbox.loadingAnnouncementText.searching': __('Searching'),
    'GlDatepicker.monthLabel': __('Month'),
    'GlDatepicker.yearLabel': __('Year'),
    'GlModal.closeButtonTitle': __('Close'),
    'GlToken.closeButtonTitle': __('Remove'),
    'GlSearchBoxByType.input.placeholder': __('Search'),
    'GlSearchBoxByType.clearButtonTitle': __('Clear'),
    'GlSorting.sortAscending': __('Sort direction: Ascending'),
    'GlSorting.sortDescending': __('Sort direction: Descending'),
    'ClearIconButton.title': __('Clear'),
    'GlKeysetPagination.prevText': PREV,
    'GlKeysetPagination.navigationLabel': s__('Pagination|Pagination'),
    'GlKeysetPagination.nextText': NEXT,
    'GlPagination.labelFirstPage': LABEL_FIRST_PAGE,
    'GlPagination.labelLastPage': LABEL_LAST_PAGE,
    'GlPagination.labelNextPage': LABEL_NEXT_PAGE,
    'GlPagination.labelPage': s__('Pagination|Go to page %{page}'),
    'GlPagination.labelPrevPage': LABEL_PREV_PAGE,
    'GlPagination.nav': s__('Pagination|Pagination'),
    'GlCollapsibleListbox.srOnlyResultsLabel': (count) => n__('%d result', '%d results', count),
    'GlProgressBar.ariaLabel': __('Progress bar'),
    'GlMultiStepFormTemplate.stepXofY': __('Step %{currentStep} of %{stepsTotal}'),
    'GlMultiStepFormTemplate.stepX': __('Step %{currentStep}'),
  },
});
